import React, { Component }    from "react";

import convolveAll             from "../lib/convolve";
import { normalize }           from "../lib/prob";
import ProbPlot                from "../components/ProbPlot";

import { Item }                from "./Items";
import AddItemButton           from "./AddItemButton";
import UnitChooser             from "./UnitChooser";
import VerbChooser             from "./VerbChooser";
import Stats                   from "./Stats";


class Calculator extends Component {

    handleChangeData(index, name, value) {
    // don't mutate state
        let newState = Object.assign({}, this.state);
        newState.items[index][name] = value;
        this.setState(newState);
    }

    handleChangeUnit(newUnit) {
        this.setState({unit: newUnit});
    }

    handleChangeVerb(newVerb) {
        this.setState({verb: newVerb});
    }

    addItem() {
        let newItems = this.state.items.concat({
            type: "BetweenXandYItem",
            min: 0,
            max: 0,
            description: ""
        })
            .concat({
                type: "UpToXItem",
                max: 0,
                description: ""
            })
            .concat({
                type: "EitherXorYItem",
                either: 0,
                or: 0,
                probOr: 0.5,
                description: ""
            });
        this.setState({items: newItems});
    }

    removeItem(index) {
        const items = [...this.state.items];
        if (items.length > 1) {
            items.splice(index, 1);
            this.setState({items: items});    
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            items: [
                { type: "BetweenXandYItem",
                    description: "Designing the screens",
                    min: 4,
                    max: 7
                },
                { type: "BetweenXandYItem",
                    description: "Building the mockups",
                    min: 2,
                    max: 3
                },
                { type: "EitherXorYItem",
                    description: "Sign-off on the mockups",
                    either: 1,
                    or: 2,
                    probOr: 0.25
                },  
                { type: "BetweenXandYItem",
                    description: "Coding the database",
                    min: 3,
                    max: 6
                },
                { type: "UpToXItem",
                    description: "Acceptance testing",
                    max: 5
                },
                { type: "EitherXorYItem",
                    description: "Legal compliance",
                    either: 2,
                    or: 14,
                    probOr: 0.25
                },  
                { type: "UpToXItem",
                    description: "Deployment scripts and provisioning",
                    max: 2
                },
            ],
            unit: "days",
            verb: "take",
        };

        this.handleChangeData = this.handleChangeData.bind(this);
        this.handleChangeUnit = this.handleChangeUnit.bind(this);
        this.handleChangeVerb = this.handleChangeVerb.bind(this);
        this.addItem = this.addItem.bind(this);
        this.removeItem = this.removeItem.bind(this);
    }

    _taskInfo() {
    // Return an array of arrays holding the probfunc for each item
        let pfs = this.state.items.map((item) => {
            return (new Item(item)).getProbFunc();
        });
        return pfs;

    }

    _ItemList() {
        return this.state.items.map((item, index) => 
        { 
            // create props from item, augmented with some ui stuff
            let props = Object.assign(item, {
                onChangeData: this.handleChangeData,
                unit: this.state.unit,
                verb: this.state.verb,
                onRemove: this.removeItem,
                removable: this.state.items.length > 1,
                key: index,
                index: index,
            });
            return (React.createElement((new Item(item)).getComponentClass(), props));
        }
        );
    }

    render() {
        let probDistFn = normalize(convolveAll(...this._taskInfo()));

        return (
            <div className="App-content container">
                <div className="row">
                    <div className="col-lg-3 order-lg-2">
                        <form>
                            <VerbChooser verb={this.state.verb} onChangeVerb={this.handleChangeVerb} />
                            <UnitChooser unit={this.state.unit} onChangeUnit={this.handleChangeUnit} />
                        </form>
                    </div>
                    <div className="col-lg-9 order-lg-1">
                        <form>
                            { this._ItemList() }
                            <AddItemButton addItem={this.addItem} />
                        </form>
                    </div>
                </div>
                <hr/>
                <div className="output row">
                    <div>
                        <ProbPlot verb={ this.state.verb } unit={ this.state.unit } probDistFn={ probDistFn } />
                    </div>
                    <div className="col-lg-4">
                        <Stats verb={ this.state.verb } unit={ this.state.unit } probDistFn={ probDistFn } />
                    </div>
                </div>
            </div>
        );
    }
}

export default Calculator;


// WEBPACK FOOTER //
// ./src/components/Calculator.js